// extracted by mini-css-extract-plugin
export default {"successContainer":"checkoutSuccess_successContainer__tZyiC","backToStoreLink":"checkoutSuccess_backToStoreLink__1Vgg4"};